import './styles/graphic.scss';
import * as d3 from 'd3';

import data from './data/data.json';

console.log('data', data);

// export default function (props, container, isMobile) {
//   // Add Show/Hide button above the grid
//   let showingAll = false;
//   const toggleButton = container.append('button')
//     .attr('id', 'toggle-button')
//     .text('+ Show all')
//     .style('border', 'none')
//     .style('cursor', 'pointer')
//     .style('margin', '16px 0');

//   // Group people by category
//   const grouped = {};
//   data.forEach((person) => {
//     const cat = person.category || 'uncategorized';
//     if (!grouped[cat]) grouped[cat] = [];
//     grouped[cat].push(person);
//   });

//   // Sort categories: hunter-biden-laptop, then others, then uncategorized
//   const categoryOrder = Object.keys(grouped).sort((a, b) => {
//     if (a === 'hunter-biden-laptop') return -1;
//     if (b === 'hunter-biden-laptop') return 1;
//     if (a === 'uncategorized') return 1;
//     if (b === 'uncategorized') return -1;
//     return a.localeCompare(b);
//   });

//   // Create the main person-grid container
//   const gridWrapper = container.append('div').attr('class', 'person-grid');

//   categoryOrder.forEach((category) => {
//     const people = grouped[category].slice().sort((a, b) => {
//       // Sort by surname within group
//       const surnameA = a.name.trim().split(' ').slice(-1)[0].toLowerCase();
//       const surnameB = b.name.trim().split(' ').slice(-1)[0].toLowerCase();
//       return surnameA.localeCompare(surnameB);
//     });

//     // Category group wrapper
//     const groupDiv = gridWrapper.append('div')
//       .attr('class', 'category-group')
//       .attr('data-category', category);

//     // Category header
//     groupDiv.append('div')
//       .attr('class', 'category-header')
//       .text(category === 'uncategorized' ? 'Other' : category.replace(/-/g, ' '));

//     // Flex container for people
//     const peopleFlex = groupDiv.append('div')
//       .attr('class', 'category-people-flex');

//     people.forEach((person) => {
//       const cell = peopleFlex.append('div')
//         .attr('class', 'person-cell');

//       const imgWrapper = cell.append('div')
//         .attr('class', `person-image-wrapper${person.category ? ` ${person.category}` : ''}`);

//       imgWrapper.append('img')
//         .attr('src', `media/${person['photo-url']}`)
//         .attr('alt', person.name)
//         .attr('class', 'person-image');

//       cell.append('div')
//         .text(person.name == 'Marc Polymeropoulos' ? 'Marc Polymerop-oulos' : person.name)
//         .attr('class', `person-name${person.category ? ` ${person.category}` : ''}`)
//         .attr('land', 'en');
//     });

//     // Adjust category group width based on the number of people
//     if (people.length > 3) {
//       groupDiv.style('grid-column', '1 / -1'); // Spans across all columns
//     }
//   });

//   // Show/Hide logic for all groups
//   function updateVisibility(showAll) {
//     gridWrapper.selectAll('.category-people-flex')
//       .classed('collapsed', !showAll);
//     toggleButton.text(showAll ? '- Show fewer' : '+ Show all');
//     if (window.pymChild) {
//       setTimeout(() => {
//         window.pymChild.sendHeight();
//       }, 50);
//     }
//   }

//   // Initially show only the first group, hide the rest
//   updateVisibility(false);

//   toggleButton.on('click', () => {
//     showingAll = !showingAll;
//     updateVisibility(showingAll);
//   });
// // ...existing code...
// }


export default function graphic() {
/**
     * CONFIG
     * Rows visible before expanding:
     * - Desktop: 2 rows
     * - Mobile: 3 rows
     */
  const ROWS_DESKTOP = 2;
  const ROWS_MOBILE = 3; // show 3 rows on mobile by default (was 4)
  const DESKTOP_MIN = 700; // px

  const categoriesEl = document.getElementById('categories');
  const catalogEl = document.getElementById('catalog');

  /**
 * Group people by category, preserving category-name.
 */
  function groupByCategory(list) {
    const map = new Map();
    for (const person of list) {
      const key = person.category;
      if (!map.has(key)) {
        map.set(key, {
          key,
          title: person['category-name'] || key,
          people: [],
        });
      }
      map.get(key).people.push(person);
    }
    // Ensure deterministic order: first by size (most people first), then by title asc
    // but always place the 'other' / uncategorized bucket last.
    return [...map.values()].sort((a, b) => {
      const aIsOther = !a.key || a.key === 'uncategorized' || String(a.key).toLowerCase() === 'other';
      const bIsOther = !b.key || b.key === 'uncategorized' || String(b.key).toLowerCase() === 'other';
      if (aIsOther && !bIsOther) return 1; // a goes last
      if (bIsOther && !aIsOther) return -1; // b goes last

      const countDiff = b.people.length - a.people.length;
      if (countDiff !== 0) return countDiff;
      return a.title.localeCompare(b.title);
    });
  }

  /**
 * Render a single category card.
 */
  function renderCategoryCard(category) {
    const card = document.createElement('article');
    card.className = 'category-card';
    card.setAttribute('data-category', category.key);

    const header = document.createElement('div');
    header.className = 'category-header';

    const title = document.createElement('h2');
    title.className = 'category-title';
    title.textContent = category.title;
    // store full title and optional mobile-short title for responsive swapping
    title.dataset.full = category.title;
    if (category.key === 'russia-interference') {
      title.dataset.mobile = 'Rus. elec. interference';
    }

    const slug = document.createElement('span');
    slug.className = 'category-slug';
    slug.textContent = `${category.people.length} people`;

    header.appendChild(title);
    header.appendChild(slug);

    // If a mobile-short title is provided, and we're on a small viewport, swap in the short title
    const applyMobileTitles = () => {
      if (window.innerWidth <= 700 && title.dataset.mobile) {
        title.textContent = title.dataset.mobile;
      } else {
        title.textContent = title.dataset.full || title.textContent;
      }
    };
    // Apply now and on resize
    applyMobileTitles();
    window.addEventListener('resize', () => applyMobileTitles());

    const people = document.createElement('div');
    people.className = 'people';

    // Sort people by surname (last name). For Biden admin, keep Joe Biden and Kamala Harris first.
    const peopleList = (category.people || []).slice();
    const getSurname = full => (full || '').trim().split(/\s+/).slice(-1)[0].toLowerCase();

    if (category.key === 'biden-admin') {
      const priority = ['Joe Biden', 'Kamala Harris'];
      const indexMap = new Map(priority.map((n, i) => [n, i]));
      peopleList.sort((a, b) => {
        const ai = indexMap.has(a.name) ? indexMap.get(a.name) : Infinity;
        const bi = indexMap.has(b.name) ? indexMap.get(b.name) : Infinity;
        if (ai !== bi) return ai - bi; // prioritized names first
        const sa = getSurname(a.name);
        const sb = getSurname(b.name);
        if (sa !== sb) return sa.localeCompare(sb);
        return a.name.localeCompare(b.name);
      });
    } else {
      peopleList.sort((a, b) => {
        const sa = getSurname(a.name);
        const sb = getSurname(b.name);
        if (sa !== sb) return sa.localeCompare(sb);
        return a.name.localeCompare(b.name);
      });
    }

    for (const p of peopleList) {
      const tile = document.createElement('div');
      tile.className = 'person';
      const img = document.createElement('img');
      img.className = 'avatar';
      img.alt = p.name;
      img.src = `media/${p['photo-url']}`; // assumes relative filenames resolve in your setup

      const name = document.createElement('div');
      name.className = 'name';
      name.title = p.name; // show full name on hover
      // Intelligent two-line break: prefer after middle initial (e.g., "Roger Z. George" -> "Roger Z"\n"George"),
      // otherwise try to balance by breaking before the last word when there are >=3 parts,
      // else break after the first word.
      const parts = p.name.trim().split(/\s+/);
      if (parts.length >= 3) {
        // detect middle initial (single letter or single letter plus dot)
        const middle = parts[1];
        if (/^[A-Za-z]\.?$/.test(middle)) {
          // break after middle initial
          name.appendChild(document.createTextNode(`${parts[0]} ${parts[1]}`));
          name.appendChild(document.createElement('br'));
          name.appendChild(document.createTextNode(parts.slice(2).join(' ')));
        } else {
          // break before last word to balance lengths
          name.appendChild(document.createTextNode(parts.slice(0, parts.length - 1).join(' ')));
          name.appendChild(document.createElement('br'));
          name.appendChild(document.createTextNode(parts[parts.length - 1]));
        }
      } else if (parts.length === 2) {
        // two-part name, break after first
        name.appendChild(document.createTextNode(parts[0]));
        name.appendChild(document.createElement('br'));
        name.appendChild(document.createTextNode(parts[1]));
      } else {
        name.textContent = p.name;
      }

      tile.appendChild(img);
      tile.appendChild(name);
      people.appendChild(tile);
    }

    card.appendChild(header);
    card.appendChild(people);

    // If this category has more than 3 people, span it across all grid columns
    if (category.people && category.people.length > 3) {
      card.style.gridColumn = '1 / -1';
    }
    return card;
  }

  /**
 * Initial render:
 * - Only the first category is visible.
 * - Others are added with [hidden] so the grid doesn't reserve space.
 */
  function renderCatalog(grouped) {
    categoriesEl.innerHTML = '';
    grouped.forEach((cat, idx) => {
      const card = renderCategoryCard(cat);
      categoriesEl.appendChild(card);
    });
  }

  /**
 * Compute and set clamp height to show N rows (based on current layout).
 * We measure a tile's height and calculate rows.
 * This runs after the first category is in the DOM.
 */
  // No clamping in static mode: the graphic is always fully expanded.

  /**
 * Expand: show all categories and remove clamp.
 */
  // expandAll/collapse not used in static mode

  /**
 * Collapse: hide all but the first category and clamp rows again.
 */
  // expand/collapse removed — show all categories by default

  /**
 * Debug helper: logs key measurements to help diagnose iframe clipping/resizing issues
 */
  function debugReportHeights(label) {
    try {
      const wrapEl = document.querySelector('.wrap');
      const catalogElLocal = document.getElementById('catalog');
      const categoriesElLocal = document.getElementById('categories');
      console.log('[layout-debug]', label || '', {
        wrap_rect: wrapEl && wrapEl.getBoundingClientRect(),
        wrap_offset: wrapEl && wrapEl.offsetHeight,
        catalog_rect: catalogElLocal && catalogElLocal.getBoundingClientRect(),
        catalog_offset: catalogElLocal && catalogElLocal.offsetHeight,
        catalog_maxHeight_inline: catalogElLocal && catalogElLocal.style.maxHeight,
        categories_scroll: categoriesElLocal && categoriesElLocal.scrollHeight,
        categories_children: categoriesElLocal && categoriesElLocal.children.length,
      });
    } catch (e) {
      console.warn('debugReportHeights failed', e);
    }
  }

  /**
 * Initialize
 */
  const grouped = groupByCategory(data);
  renderCatalog(grouped);
  // Static: show everything. No collapse/clamp applied.
  // Send initial height to parent so embedded frames can size correctly.
  // (sendHeightToParent is defined below)


  // No toggle button or resize-based clamping in static mode.


  // if your code just runs side effects, you can leave this empty
  // or move your init code into this function

  function sendHeightToParent(delay = 50) {
    try {
      if (window.pymChild) {
        setTimeout(() => {
          try { window.pymChild.sendHeight(); } catch (e) { console.warn('pym sendHeight failed', e); }
        }, delay);
      } else if (window.parent) {
        // fallback postMessage notifying parent that layout changed; parent must opt-in to listen
        setTimeout(() => {
          try { window.parent.postMessage({ type: 'embed:heightChange', height: document.body.scrollHeight }, '*'); } catch (e) { }
        }, delay);
      }
    } catch (e) {
      console.warn('sendHeightToParent failed', e);
    }
  }
  // send initial height after layout
  sendHeightToParent(100);
}
